import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaxDateRangeDirective } from './max-date-range.directive';

@NgModule({
  declarations: [MaxDateRangeDirective],
  exports: [MaxDateRangeDirective],
  imports: [CommonModule],
})
export class MaxDateRangeModule {}
